// 🏆 My Favorite Musicians Achievement Definitions
// These auto-sync to Firebase when the game loads

import { AchievementDefinition } from '../services/GameAPI';

export const MY_FAVORITE_MUSICIANS_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "first_entry",
    gameId: "my-favorite-musicians",
    title: "Getting Started",
    description: "Added your first musical preference! Everyone starts their musical journey somewhere.",
    iconUrl: "🎵",
    museCashReward: 25,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "progression"
  },
  {
    id: "genre_explorer", 
    gameId: "my-favorite-musicians",
    title: "Genre Explorer",
    description: "Discovered 3 different genres! Your musical taste is expanding across different styles.",
    iconUrl: "🌍",
    museCashReward: 75,
    type: "diversity",
    rarity: "common", 
    implemented: true,
    sortOrder: 2,
    category: "diversity"
  },
  {
    id: "music_historian",
    gameId: "my-favorite-musicians", 
    title: "Music Historian",
    description: "Added 2 classic artists! You appreciate the timeless legends of music history.",
    iconUrl: "📚",
    museCashReward: 100,
    type: "special",
    rarity: "rare",
    implemented: true,
    sortOrder: 3,
    category: "knowledge"
  },
  {
    id: "modern_music_fan",
    gameId: "my-favorite-musicians",
    title: "Modern Music Fan", 
    description: "Added 2 contemporary artists! You stay current with today's music scene.",
    iconUrl: "🎤",
    museCashReward: 100,
    type: "special",
    rarity: "rare",
    implemented: true,
    sortOrder: 4,
    category: "knowledge"
  },
  {
    id: "speed_typer",
    gameId: "my-favorite-musicians",
    title: "Speed Typer",
    description: "Completed your list in under 3 minutes! Lightning-fast musical preferences.",
    iconUrl: "⚡",
    museCashReward: 150,
    type: "performance", 
    rarity: "epic",
    implemented: true,
    sortOrder: 5,
    category: "skill"
  },
  {
    id: "shared_music_taste",
    gameId: "my-favorite-musicians",
    title: "Shared My Music Taste",
    description: "Completed your musical preference list! You've successfully shared your unique musical taste with the world.",
    iconUrl: "🎉",
    museCashReward: 200,
    type: "completion",
    rarity: "epic",
    implemented: true,
    sortOrder: 6,
    category: "completion"
  }
]; 